var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":{ name: 'serial-detail', params: { slug: _vm.serial.serial_slug }}}},[_c('img',{staticClass:"column rounded",attrs:{"src":_vm.mediaUrl + '/' + _vm.serial.serial_poster}})])
}
var staticRenderFns = []

export { render, staticRenderFns }